import { render, staticRenderFns } from "./VendorManage.vue?vue&type=template&id=0645d691&scoped=true&"
import script from "./VendorManage.vue?vue&type=script&lang=js&"
export * from "./VendorManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0645d691",
  null
  
)

export default component.exports